var React = require('react');

function DraggableDivider (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Frame 118"},[React.createElement("circle",{"id":"Ellipse 2","cx":"23.7773","cy":"23.8867","r":"23.5","fill":"white","key":0}),React.createElement("circle",{"id":"Ellipse 3","cx":"23.7773","cy":"23.8867","r":"19","fill":"white","stroke":"black","key":1}),React.createElement("path",{"id":"Vector 1","d":"M18.2773 18.3867V30.3867","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"id":"Vector 2","d":"M23.2773 16.3867V33.3867","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":3}),React.createElement("path",{"id":"Vector 3","d":"M28.2773 18.3867V30.3867","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":4})]));
}

DraggableDivider.defaultProps = {"width":"49","height":"49","viewBox":"0 0 49 49","fill":"none"};

module.exports = DraggableDivider;

DraggableDivider.default = DraggableDivider;
